/* Uzzora · Version B landing page behaviour: gallery, results carousel, bundle selection, sticky add to cart,
   add to cart into the theme's cart drawer.
   Add to cart itself is a normal form post to /cart/add and works without this file. */
(function () {
  'use strict';

  function initGallery(gal) {
    if (gal.dataset.uzbReady) return;
    gal.dataset.uzbReady = '1';
    var track = gal.querySelector('[data-uzb-track]');
    if (!track) return;
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-uzb-thumb]'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-uzb-dot]'));
    var count = track.children.length;
    var current = 0;
    // Results carousel (data-uzb-results): clickable dots, arrow keys, and no dot flicker while it slides.
    var results = gal.hasAttribute('data-uzb-results');
    var target = -1;
    var targetTimer = 0;

    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        if (d.tagName === 'BUTTON') d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      var t = thumbs[i];
      var box = t && t.parentNode;
      if (box && box.scrollHeight > box.clientHeight + 2) {
        box.scrollTo({ top: t.offsetTop - box.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
      }
    }
    function go(i, instant) {
      if (!count) return;
      i = (i + count) % count;
      if (results && !instant) {
        target = i;
        clearTimeout(targetTimer);
        targetTimer = setTimeout(function () { target = -1; }, 900);
      }
      track.scrollTo({ left: track.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) {
      if (d.tagName === 'BUTTON') d.addEventListener('click', function () { go(k); });
    });
    var prev = gal.querySelector('[data-uzb-prev]');
    var next = gal.querySelector('[data-uzb-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (target > -1) {
          if (i === target) target = -1;
          return;
        }
        if (i !== current && i >= 0 && i < count) mark(i);
      });
    }, { passive: true });
    window.addEventListener('resize', function () { track.scrollLeft = track.clientWidth * current; });
    gal.uzbGo = go;

    if (results) {
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      });
      // A finger or the trackpad takes over from a slide that is still animating.
      ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
        track.addEventListener(ev, function () { target = -1; }, { passive: true });
      });
      // The slides that start off screen load their images as the carousel comes near, so a swipe never shows an empty frame.
      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          near.disconnect();
          gal.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        }, { rootMargin: '600px 0px' });
        near.observe(gal);
      }
    }
  }

  function initBuy(form) {
    if (form.dataset.uzbReady) return;
    form.dataset.uzbReady = '1';
    var radios = function () { return Array.prototype.slice.call(form.querySelectorAll('input[name="quantity"]')); };

    function sync() {
      var sel = form.querySelector('input[name="quantity"]:checked') || radios()[0];
      if (!sel) return;
      radios().forEach(function (r) { r.closest('.uzb-bn').classList.toggle('is-on', r === sel); });
      document.querySelectorAll('[data-uzb-price]').forEach(function (el) { el.textContent = sel.dataset.price; });
      document.querySelectorAll('[data-uzb-sel]').forEach(function (el) { el.textContent = sel.dataset.title; });
      document.querySelectorAll('[data-uzb-mirror] input').forEach(function (m) {
        m.checked = m.value === sel.value;
        m.closest('.uzb-bn').classList.toggle('is-on', m.checked);
      });
    }
    form.addEventListener('change', sync);

    // Mirror the bundle cards into other sections (final call to action) so they are edited in one place.
    document.querySelectorAll('[data-uzb-mirror]').forEach(function (holder, n) {
      var src = form.querySelector('[data-uzb-bundles]');
      if (!src) return;
      holder.innerHTML = '';
      var copy = src.cloneNode(true);
      copy.removeAttribute('data-uzb-bundles');
      copy.querySelectorAll('input').forEach(function (inp) {
        inp.name = 'uzb-mirror-' + n;
        inp.removeAttribute('id');
        inp.addEventListener('change', function () {
          var target = form.querySelector('input[name="quantity"][value="' + inp.value + '"]');
          if (target) { target.checked = true; sync(); }
        });
      });
      holder.appendChild(copy);
    });
    sync();

    form.addEventListener('submit', function () {
      document.querySelectorAll('.uzb-btn[type="submit"]').forEach(function (b) { b.classList.add('is-busy'); });
    });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('.uzb-btn.is-busy').forEach(function (b) { b.classList.remove('is-busy'); });
    });

    // Sticky add to cart: shown once the main button has scrolled out of view.
    var stick = document.querySelector('[data-uzb-stick]');
    var main = form.querySelector('[type="submit"]');
    if (stick && main && 'IntersectionObserver' in window) {
      var visible = {};
      var update = function () {
        var anyVisible = Object.keys(visible).some(function (k) { return visible[k]; });
        var pastMain = main.getBoundingClientRect().top < 0;
        var sections = document.querySelectorAll('.uzb-section');
        var last = sections[sections.length - 1];
        var pastEnd = last && last.getBoundingClientRect().bottom < window.innerHeight - 20;
        stick.classList.toggle('is-on', pastMain && !anyVisible && !pastEnd);
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible[e.target.dataset.uzbWatch] = e.isIntersecting; });
        update();
      });
      var watch = [main].concat(Array.prototype.slice.call(document.querySelectorAll('[data-uzb-hide-stick]')));
      watch.forEach(function (el, k) { el.dataset.uzbWatch = 'w' + k; io.observe(el); });
      window.addEventListener('scroll', update, { passive: true });
    }
  }

  // Add to cart into the theme's cart drawer. Covers every Version B add to cart form: the product
  // buy box (and all buttons tied to it, including the sticky bar) and the home page sets.
  // It adds by fetch and hands the result to the theme's own <cart-drawer>, the same way the theme's
  // product form does. If the theme has no cart drawer, the form is set to go to checkout, or the
  // request fails, the form posts normally and the cart page opens.
  function setBusy(on) {
    document.querySelectorAll('.uzb-btn[type="submit"]').forEach(function (b) { b.classList.toggle('is-busy', on); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.uzb form[action*="/cart/add"]')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') return;
    if (!window.fetch || !window.FormData) return;
    var back = form.querySelector('[name="return_to"]');
    if (back && back.value.indexOf('checkout') !== -1) return;

    e.preventDefault();
    if (form.dataset.uzbAdding) return;
    form.dataset.uzbAdding = '1';
    setBusy(true);
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);

    var data = new FormData(form);
    data.delete('return_to');
    data.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    data.append('sections_url', window.location.pathname);
    var url = (window.routes && window.routes.cart_add_url) || form.getAttribute('action');

    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: data })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status || !state.sections) throw new Error('add to cart failed');
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        delete form.dataset.uzbAdding;
        setBusy(false);
      })
      .catch(function () {
        // Fall back to the normal form post, which shows the cart page (or Shopify's own error).
        form.submit();
      });
  });
  // Coming back with the browser's back button: make the buttons usable again.
  window.addEventListener('pageshow', function () {
    setBusy(false);
    document.querySelectorAll('form[data-uzb-adding]').forEach(function (f) { delete f.dataset.uzbAdding; });
  });

  function init() {
    document.querySelectorAll('[data-uzb-gal]').forEach(initGallery);
    document.querySelectorAll('[data-uzb-buy]').forEach(initBuy);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-uzb-buy]').forEach(function (f) { delete f.dataset.uzbReady; });
    init();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.parentNode && el.parentNode.hasAttribute && el.parentNode.hasAttribute('data-uzb-track')) {
      var gal = el.closest('[data-uzb-gal]');
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      if (gal && gal.uzbGo) gal.uzbGo(i, true);
    }
    if (el.tagName === 'DETAILS') el.open = true;
  });
})();
